module.exports = __webpack_public_path__ + "static/media/apple_app_store.d48676a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/apple_app_store.png
// module id = 602
// module chunks = 0